import React from "react";
import { PageTitle } from "../../PageTitle";
import ImageGallery from "../../components/ImageGallery/ImageGallery";
import { scrollToApplication } from "../../hooks/scrollTo";
import {
  SectionHeader,
  SectionHeaderSemibold,
  BodyText,
  BodyTextBold,
  BodyTextSemibold,
  MediumHeaderBold,
  LargeTextLight,
} from "../../styles/Typography";
import {
  IconVerified,
  IconHouse,
  IconWeb,
  IconFont,
} from "../../assets/icons/Icon";
import StatisticsCard from "../../components/StatisticsCard/StatisticsCard";
import Button from "../../components/Button/Button";
import ApplicationFooter from "../../components/Footer/ApplicationFooter";
import lukoilLetter from "./pictures/lukoil-letter.jpg";
import mainPicture from "./pictures/staff-training.png";
import idt from "./pictures/idt.jpg";
import sertificate from "./pictures/sertificate.png";
import license1 from "./pictures/license-1.jpg";
import license2 from "./pictures/license-2.jpg";
import {
  Container,
  MainSection,
  TextFlex,
  TextLine,
  DirectionsOfStudy,
  DirectionsGrid,
  DirectionOfStudy,
  AccentCard,
  ButtonBlock,
  MainPictureContainer,
  MainPicture,
  MainTextContainer,
  MainCTAContainer,
  InfoSection,
  InfoContainer,
  InfoBlock,
  InfoHeading,
  LetterSection,
  LetterOfRecognition,
  LetterTextBlock,
  LetterTextBlockInner,
  StatsCard,
  LetterStatsContainer,
  IdtImage,
  LicenseSection,
  LicenseInnerContainer,
  Licenses,
  LicenseImage,
  LicenseTextBrake,
  LicenseHeaderBrake,
  SertificateSection,
  SertificateImage,
  SectionHeading,
  SectionHeadingCenter,
} from "./StaffTraining.styles";

const StaffTraining: React.FC = () => {
  return (
    <Container>
      <PageTitle title="Обучение персонала — Интеллект-Развитие-Технологии" />
      <MainSection id="staff-training">
        <TextFlex>
          <MainTextContainer>
            <SectionHeader>обучение персонала</SectionHeader>
            <BodyText>
              Наши лучшие специалисты с многолетним опытом работы в ведущих
              сервисных компаниях предоставляют услуги по проведению обучения и
              технических консультаций в области цементирования,
              наклонно-направленного бурения скважин, крепления обсадных колонн,
              буровых растворов, ГРП и супервайзинга в бурении.
            </BodyText>
            <DirectionsOfStudy>
              <TextLine>
                <LargeTextLight>*</LargeTextLight>
                <BodyTextBold>Направления экспертного обучения:</BodyTextBold>
              </TextLine>
              <DirectionsGrid>
                <DirectionOfStudy>
                  <BodyTextSemibold>Цементирование</BodyTextSemibold>
                </DirectionOfStudy>
                <DirectionOfStudy>
                  <BodyTextSemibold>
                    Гидравлический разрыв пласта
                  </BodyTextSemibold>
                </DirectionOfStudy>
                <DirectionOfStudy>
                  <BodyTextSemibold>Безаварийное бурение</BodyTextSemibold>
                </DirectionOfStudy>
                <DirectionOfStudy>
                  <BodyTextSemibold>
                    Наклонно-направленное бурение
                  </BodyTextSemibold>
                </DirectionOfStudy>
                <DirectionOfStudy>
                  <BodyTextSemibold>Буровые растворы</BodyTextSemibold>
                </DirectionOfStudy>
              </DirectionsGrid>
            </DirectionsOfStudy>
          </MainTextContainer>
          <MainCTAContainer>
            <AccentCard>
              <span>
                <IconVerified />
              </span>
              <BodyText>
                Мы обучаем <b>по стандартам API, ГОСТ,</b> а также лучшим
                практикам мировых компаний и SPE.{" "}
                <b>Наши преподаватели -- кандидаты технических наук.</b>
              </BodyText>
            </AccentCard>
            <ButtonBlock>
              <Button variant="arrow" onClick={scrollToApplication}>
                Оставить заявку на обучение
              </Button>
            </ButtonBlock>
          </MainCTAContainer>
        </TextFlex>

        <MainPictureContainer>
          <MainPicture $image={mainPicture}>
            <img
              src={mainPicture}
              alt="Пример экрана онлайн-лекции ООО “Интеллект-Развитие-Технологии”"
              loading="eager"
              decoding="async"
            />
          </MainPicture>
          <TextLine>
            <LargeTextLight>*</LargeTextLight>
            <BodyText>
              Пример экрана онлайн-лекции ООО “Интеллект-Развитие-Технологии”
            </BodyText>
          </TextLine>
        </MainPictureContainer>
      </MainSection>

      <InfoSection id="training-info">
        <InfoContainer>
          <InfoBlock>
            <span>
              <IconWeb />
            </span>
            <InfoHeading>
              <BodyTextBold>Формат обучения</BodyTextBold>
              <BodyText>
                Доступны очный и дистанционный формат обучения
              </BodyText>
            </InfoHeading>
          </InfoBlock>
          <InfoBlock>
            <span>
              <IconFont />
            </span>
            <InfoHeading>
              <BodyTextBold>Язык обучения</BodyTextBold>
              <BodyText>
                Обучение возможно на русском или английском языке
              </BodyText>
            </InfoHeading>
          </InfoBlock>
          <InfoBlock>
            <span>
              <IconHouse />
            </span>
            <InfoHeading>
              <BodyTextBold>Место проведения</BodyTextBold>
              <BodyText>
                На объектах Заказчика или на учебной базе ООО “ИРТ” в г. Тюмень
              </BodyText>
            </InfoHeading>
          </InfoBlock>
        </InfoContainer>
      </InfoSection>

      <LetterSection id="letter-of-recognition">
        <ImageGallery
          images={[
            { src: lukoilLetter, alt: "Благодарственное письмо компании" },
          ]}
        >
          {({ openGallery }) => (
            <LetterOfRecognition
              $image={lukoilLetter}
              onClick={() => openGallery(0)}
            >
              <img
                src={lukoilLetter}
                alt="Благодарственное письмо компании"
                loading="lazy"
                decoding="async"
              />
            </LetterOfRecognition>
          )}
        </ImageGallery>

        <LetterTextBlock>
          <MediumHeaderBold>Экспертиза, которой доверяют</MediumHeaderBold>
          <LetterTextBlockInner>
            <BodyText>
              Благодарность от ООО «ЛУКОЙЛ-Инжиниринг» — это оценка нашего
              подхода к обучению.{" "}
            </BodyText>
            <BodyText>
              В 2026 году мы провели курс «Basic, LD & Advanced» в
              онлайн-формате для специалистов компании. Участники курса отметили
              глубокие знания в области крепления скважин, качество учебных
              материалов и ясность изложения. {" "}
            </BodyText>
            <BodyText>
              <b>100% слушателей рекомендовали курс коллегам. </b>
              <br />
              Мы не просто делимся опытом — мы формируем стандарты
              профессиональной подготовки в отрасли и доказываем эффективность
              не только на промысле, но и в обучении.
            </BodyText>
          </LetterTextBlockInner>
          <Button variant="arrow" outlined onClick={scrollToApplication}>
            Узнать программу
          </Button>
        </LetterTextBlock>
        <LetterStatsContainer>
          <StatsCard>
            <StatisticsCard
              number="60+"
              subtitle="проведенных курсов"
              backgroundColor="#5D697CE6"
              textColor="#F2F5F8"
            />
          </StatsCard>
          <IdtImage $image={idt}>
            <img
              src={idt}
              alt="Интеллект-Развитие-Технологии"
              loading="lazy"
              decoding="async"
            />
          </IdtImage>
        </LetterStatsContainer>
      </LetterSection>

      <LicenseSection id="license">
        <SectionHeadingCenter>
          <SectionHeaderSemibold>аккредитация</SectionHeaderSemibold>
        </SectionHeadingCenter>
        <LicenseInnerContainer>
          <MediumHeaderBold>
            Лицензия <LicenseHeaderBrake />
            на образовательную деятельность <LicenseTextBrake />№ 049 от 16 июля
            2018 года
          </MediumHeaderBold>

          <ImageGallery
            images={[
              {
                src: license1,
                alt: 'Образовательная лицензия ООО "ИРТ" от 16.07.2018',
              },
              {
                src: license2,
                alt: 'Приложение к образовательной лицензии ООО "ИРТ" от 16.07.2018',
              },
            ]}
          >
            {({ openGallery }) => (
              <Licenses>
                <LicenseImage $image={license1} onClick={() => openGallery(0)}>
                  <img
                    src={license1}
                    alt='Образовательная лицензия ООО "ИРТ" от 16.07.2018'
                    loading="lazy"
                    decoding="async"
                  />
                </LicenseImage>
                <LicenseImage $image={license2} onClick={() => openGallery(1)}>
                  <img
                    src={license2}
                    alt='Приложение к образовательной лицензии ООО "ИРТ" от 16.07.2018'
                    loading="lazy"
                    decoding="async"
                  />
                </LicenseImage>
              </Licenses>
            )}
          </ImageGallery>
        </LicenseInnerContainer>
      </LicenseSection>

      <SertificateSection id="certificate">
        <SectionHeading>
          <SectionHeaderSemibold>Сертификат</SectionHeaderSemibold>
          <BodyTextBold>
            выдается после успешного <br />
            прохождения экзаменов
          </BodyTextBold>
        </SectionHeading>
        <ImageGallery
          images={[{ src: sertificate, alt: "Сертификат после обучения" }]}
        >
          {({ openGallery }) => (
            <SertificateImage
              $image={sertificate}
              onClick={() => openGallery(0)}
            >
              <img
                src={sertificate}
                alt="Сертификат после обучения"
                loading="lazy"
                decoding="async"
              />
            </SertificateImage>
          )}
        </ImageGallery>
      </SertificateSection>

      <ApplicationFooter />
    </Container>
  );
};

export default StaffTraining;
